import {Alerts} from "./Alerts";

export class OrderValidation {

    static init(selector) {

        if (window.location.href.includes('orders')) {
            $(document).keypress(
                function(event){
                    if (event.which == '13') {
                        event.preventDefault();
                    }
                });
        }

        // Initialize purchase order validation for create and edit-completed pages
        if (window.location.href.includes('orders/create') || window.location.href.includes('orders/') && window.location.href.includes('/edit-completed')) {
            OrderValidation.initPurchaseOrderValidation();
        }

        if(window.location.href.includes('orders/create')) {



            $('#orderForm', selector).on('click change keyup keydown focus',(e) => {

                OrderValidation.shippingValidation()

                if (OrderValidation.generalValidation($(e.currentTarget)))
                    $('button[data-target="#collapseItems"]').prop('disabled', false);
                else
                    $('button[data-target="#collapseItems"]').prop('disabled', true);


                if (OrderValidation.itemsValidation($(e.currentTarget)))
                    $('button[data-target="#collapsePayments"]').prop('disabled', false);
                else
                    $('button[data-target="#collapsePayments"]').prop('disabled', true);

                if (OrderValidation.paymentValidation($(e.currentTarget)) && OrderValidation.generalValidation($(e.currentTarget)) && OrderValidation.itemsValidation($(e.currentTarget)))
                    $('.btn-confirmOrder').prop('disabled', false);
                else
                    $('.btn-confirmOrder').prop('disabled', true);

                if(OrderValidation.shippingValidation($(e.currentTarget)))
                    $('#addShippingBtn').prop('disabled', false)
                else
                    $('#addShippingBtn').prop('disabled', true)


            })

            let $replicate_checkbox = $('#replicate_billing');
            let $inputCustomer = $('#inputCustomer');
            $replicate_checkbox.on('click', function () {

                let $billingElement = $('#inputBilling');

                let $shippingElement = $('#inputShipping');
                let $shippingElementBtn = $('#inputShippingBtn');
                let $shippingContainer = $('.shippingAddressContainer');

                let sApiBilling = $billingElement[0].selectize;
                let sApiShipping = $shippingElement[0].selectize;

                console.log('on click', 1)
                if ($inputCustomer[0].selectize.getValue()) {
                    console.log('on click', 2)
                    if ($replicate_checkbox.prop('checked')) {
                        console.log('on click val', sApiShipping.getOption(42324), sApiBilling.getOption(42324))

                        setTimeout(() => {console.log(sApiShipping.getOption(42324))}, 5000)

                        sApiShipping.setValue(sApiBilling.getValue());
                        $shippingElementBtn.prop('disabled', true);
                        $shippingElementBtn.addClass('disabled');
                        sApiShipping.disable();
                        $shippingContainer.addClass('d-none');
                    } else {
                        sApiShipping.clear();
                        $shippingElementBtn.prop('disabled', false);
                        $shippingElementBtn.removeClass('disabled');
                        sApiShipping.enable();
                        $shippingContainer.removeClass('d-none');
                    }
                }

            })


        }
        else {
            $('button[data-target="#collapseItems"]').prop('disabled', false);
            $('button[data-target="#collapsePayments"]').prop('disabled', false);
            $('.btn-confirmOrder').prop('disabled', false);
        }
    }

    static generalValidation(area) {
        let companyVal = $('[name="company_id"]', area).val();
        let orderType = $('[name="order_type"]', area).val();

        if (companyVal == null || companyVal === '' || orderType == null || orderType === '') {
            return false;
        }

        return true;
    }

    static itemsValidation(area) {
        let $repeater = $('[data-repeater-list="items"]', area);

        if ($repeater.children().length <= 1) {
            return false;
        }

        return true;
    }

    static paymentValidation(area) {
        if ($('.payment-area', area).attr('data-credit-note-covers-order') == 'true') {
            return true;
        }
        else {
            let paymentType = $('[name="payment_type"]', area).val();
            if (paymentType != null && paymentType !== '') {
                return true;
            }
        }

        return false;
    }

    static shippingValidation(area) {
        let errors = [];
        let requiredForShipping = [$('#inputShipping')]

        requiredForShipping.forEach(function (element, index, array) {
            if(!$(element).val())
                errors.push(element)
        })

        if (!this.itemsValidation(area))
            errors.push($('[data-init="initJRepeaterProducts"]'))

        return !errors.length

    }

    static initPurchaseOrderValidation() {
        // Create debounced version of the check function
        const debouncedCheck = _.debounce((input) => {
            OrderValidation.purchaseOrderCheck(input);
        }, 500);

        // Bind to purchase order input fields
        $(document).on('input keyup', '#inputPurchaseOrderNumber, #purchaseOrderNumber', function() {
            debouncedCheck($(this));
        });
    }

    static purchaseOrderCheck(input) {
        const purchaseOrderNumber = input.val();
        const warningContainer = input.closest('.form-group').find('[data-po-warning]');
        const excludeOrderId = input.data('exclude-order');

        // Clear warning if empty
        if (!purchaseOrderNumber || purchaseOrderNumber.trim() === '') {
            warningContainer.html('');
            return;
        }

        // Build request params
        const params = {
            purchase_order_number: purchaseOrderNumber
        };

        if (excludeOrderId) {
            params.exclude_order_id = excludeOrderId;
        }

        $.ajax({
            url: '/api/orders/check-purchase-order',
            method: 'GET',
            data: params,
            success: function(response) {
                if (response.exists && response.orders.length > 0) {
                    const orderLinks = response.orders.map(order =>
                        `<a href="${order.url}" target="_blank">#${order.id}</a>`
                    ).join(', ');

                    warningContainer.html(
                        `<div class="alert alert-warning mt-2 mb-0">` +
                        `This Purchase Order Number is already used by order(s): ${orderLinks}` +
                        `</div>`
                    );
                } else {
                    warningContainer.html('');
                }
            },
            error: function() {
                // Silently fail - don't block the form
                warningContainer.html('');
            }
        });
    }
}
